import { defineComponent as _defineComponent } from 'vue'
import { useContext, useStore } from '@nuxtjs/composition-api';
import { State } from '~/store';
import TLinkButton from '~/components/atoms/t-link-button.vue';
import { getGradeValueFromLabel } from '~/data/grades';
import { File, ResourceTags } from '~/types/resource';
import { Locale } from '~/types/locale';


export default /*#__PURE__*/_defineComponent({
  __name: 'TagList',
  props: {
    fileFormats: null,
    tags: null,
    yearLevels: null,
    country: null,
    title: null
  },
  setup(__props: any) {

const props = __props as {
  fileFormats: File[];
  tags: ResourceTags[];
  yearLevels: string[];
  country: Locale;
  title?: string;
};

const { localePath } = useContext();
const store = useStore<State>();



const yearLevelLink = (slug: string) => {
  // hard coding for the moment as making any change to API payload will mean update at many places
  // we might be using year_levels. With Strapi we might end up not needing this.
  const path = props.country === 'us' ? '/grade-level/' : '/year-level/';
  return localePath(path + getGradeValueFromLabel(props.country, slug));
};

return { __sfc: true,localePath, store, props, yearLevelLink, TLinkButton }
}

})